function cov_kho02a6py() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close.tsx";
  var hash = "1e89307570a95f6cedef1cd412978432b7d6505f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1e89307570a95f6cedef1cd412978432b7d6505f"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_kho02a6py = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_kho02a6py();
var Icon = (cov_kho02a6py().s[0]++, {
  name: 'close',
  svg: "<path d=\"M18.5409 7.22666C19.029 6.7385 19.029 5.94705 18.5409 5.45889C18.0527 4.97073 17.2612 4.97073 16.7731 5.45889L11.9997 10.2322L7.22715 5.45963C6.73899 4.97148 5.94753 4.97148 5.45938 5.45963C4.97122 5.94779 4.97122 6.73924 5.45938 7.2274L10.232 12L5.45938 16.7726C4.97123 17.2608 4.97123 18.0522 5.45938 18.5404C5.94754 19.0285 6.73899 19.0285 7.22715 18.5404L11.9997 13.7678L16.7731 18.5411C17.2612 19.0293 18.0527 19.0293 18.5409 18.5411C19.029 18.053 19.029 17.2615 18.5409 16.7733L13.7675 12L18.5409 7.22666Z\" fill=\"currentColor\"/>"
});
export default Icon;